import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../CustomerValueAgreements.module.scss';
import { CvaListTypeProps } from '../../types';

export const CVAListType = ({ children }: CvaListTypeProps) => {
  return (
    <CatHeading
      variant="body-sm"
      className={styles['cva-modal-wrapper--list-type']}
    >
      {children}
    </CatHeading>
  );
};
